import React, { useEffect, useState } from "react";
import { View, Image, TouchableOpacity, Text, KeyboardAvoidingView, Keyboard, Platform } from "react-native";
import CText from "./CText";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

export default function CCheckboxWithLabel({
    textColor,
    textDecorationLine,
    setIsTermsChecked,
    isTermsChecked,
    termsText,
    termsText2,
    onPress,
    TermsAndCondition,
    backgroundColor,
    value,
    onValueChange,
    label,
    isFullTap = true,
    containerStyle = {},
    style = {},
    ...otherProps
}) {
    const styles = useStyles();
    const [keyboardVisible, setKeyboardVisible] = useState(false);

    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener("keyboardDidShow", () => {
            setKeyboardVisible(true);
        });
        const keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", () => {
            setKeyboardVisible(false);
        });

        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);

    const TncText = () => {
        return (
            <CText.headerDesc style={{ flexWrap: "wrap", color: textColor ? textColor : "#212121" }}>
                {label}
                <TouchableOpacity onPress={onPress}>
                    <Text style={{ textDecorationLine: textDecorationLine ? textDecorationLine : "underline", fontWeight: "bold" }}>
                        {TermsAndCondition}
                    </Text>
                </TouchableOpacity>{" "}
                {termsText2}
            </CText.headerDesc>
        );
    };

    return (
        <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : null} style={{ flex: 1 }}>
            <View style={[styles.contentWrapper, keyboardVisible ? styles.contentWrapperKeyboard : {}]}>
                <TouchableOpacity
                    onPress={() => {
                        setIsTermsChecked(!isTermsChecked);
                    }}
                    style={[
                        styles.radiobuttonOutSideStyle,
                        {
                            width: 15.9,
                            height: 15.9,
                            borderRadius: 3,
                            borderColor: "#c3c3c3",
                            backgroundColor: isTermsChecked ? backgroundColor || "#666666" : "transparent",
                        },
                    ]}
                >
                    {isTermsChecked && <Image source={require("./../assets/images/termsChecked.png")} style={{ width: 12, height: 12 }} />}
                </TouchableOpacity>

                <View style={{ paddingLeft: 10, width: "90%" }}>
                    <TncText />
                </View>
            </View>
        </KeyboardAvoidingView>
    );
}

const useStyles = CreateResponsiveStyle(
    {
        contentWrapper: {
            flexDirection: "row",
            marginTop: 10,
        },
        contentWrapperKeyboard: {
            marginBottom: 20, // Adds spacing when keyboard is open
        },
        radiobuttonOutSideStyle: {
            width: 15,
            height: 15,
            borderRadius: 10,
            borderColor: "#9d1d27",
            borderWidth: 2,
            alignItems: "center",
            justifyContent: "center",
            marginLeft: 10,
        },
    },
    {
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: {},
        [DEVICE_SIZES.SM]: {},
        [DEVICE_SIZES.XS]: {
            contentWrapper: {
                paddingLeft: 0,
            },
        },
    }
);
